import { FlowTypes } from '@adaptis/flow-components';
import { PetType } from '../../util/common-types';

export interface ICoveredPetProps {
  id: string;
  step?: FlowTypes.IFlowStep;
  title: string;
  animal: PetType;
  status: CoveredPetStatus;
  summaryMode: CoveredPetSummaryMode;
  className?: string;
  summaryItems?: ICoveredPetSummaryItem[];
  onActionClick?: (
    action: CoveredPetAction,
    animalId: string,
    name?: string
  ) => void;
  paymentFrequency?: string;
  petAgeCategory?: number;
}

export interface ICoveredPetSummaryItem {
  label: string;
  staticText?: string;
  dataField?: string;
  format?: string;
  showIfEmpty?: boolean;
}

export enum CoveredPetStatus {
  Untouched = 'untouched',
  Configured = 'configured',
  Incomplete = 'incomplete',
}
export enum CoveredPetSummaryMode {
  Link = 'link',
  Button = 'button',
}
export enum CoveredPetAction {
  Edit = 'edit',
  Delete = 'delete',
}
